// extracted by mini-css-extract-plugin
export default {"list":"smart_suggestions_list___list___c8e6be67","listTitle":"smart_suggestions_list___listTitle___dab12c9e","refresh":"smart_suggestions_list___refresh___c23dc19a"};